import React from 'react';
import styles from './Outcomes.module.scss';
import OddsButton from '../../../../../shared/OddsButton/OddsButton';
import { LANGUAGES, ODDS_BUTTON_TYPES } from '../../../../../../constants/defaultValues';
import { Tooltip } from '@material-ui/core';
import { formatSpecifierName, renderOdd } from '../../../../../../utils/render';
import { useDispatch, useSelector } from 'react-redux';
import { addBetSlipBetLine, deleteBetSlipBetLine } from '../../../../../../store/actions/betSlip';
import { sortOutcomeValues } from '../../../../../../utils/helpers';
import { generateRegularBetLine } from '../../../../../../utils/betSlip';

const Outcomes = ({ market, teams, tournamentName }) => {
    const dispatch = useDispatch();
    const locale = useSelector(state => state.settings.locale);
    const betLines = useSelector(state => state.betSlip.betLines);
    const selectedEvent = useSelector(state => state.eventDetails.event);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);

    const { playerNames } = selectedEvent;

    const renderOddContent = ({ odd, marketStatus, outcomeStatus, isFrozen }) => {
        return renderOdd({ odd, marketStatus, outcomeStatus, isFrozen });
    };

    const checkSelectedOdd = (outcomeId, marketId) => {
        return betLines.some(bet => bet.marketId === marketId && bet.outcomeId === outcomeId);
    };

    const addToSlipHandler = (market, outcome) => {
        dispatch(
            addBetSlipBetLine(generateRegularBetLine({ event: selectedEvent, market, outcome })),
        );
    };

    const onRemoveFromSlip = removedBet => {
        dispatch(deleteBetSlipBetLine(removedBet));
    };

    return (
        <div className={'flex flex-wrap'}>
            {sortOutcomeValues(market.outcomes).map(outcome => {
                if (!market.outcomeNames) return null;

                const isSelected = checkSelectedOdd(outcome.outcomeRefId, market.id);

                const foundOutcomeName = market.outcomeNames.find(
                    o => o.id === outcome.outcomeRefId,
                );
                const playerName = selectedEvent.playerNames[outcome.outcomeRefId];
                const outcomeName =
                    playerName ||
                    foundOutcomeName?.names[locale] ||
                    foundOutcomeName?.names[LANGUAGES.eng];

                const isClosed =
                    market.closed || market.status !== 0 || outcome.status !== 0 || outcome.closed;
                const isFrozen =
                    market.frozen ||
                    (selectedEvent.live && producerStatuses.isLiveDown) ||
                    (!selectedEvent.live && producerStatuses.isPreMatchDown);

                return outcomeName ? (
                    <div
                        key={outcome.outcomeRefId}
                        className={styles.outcome}
                        style={{
                            width:
                                market.outcomes.length <= 3
                                    ? `${100 / market.outcomes.length}%`
                                    : '33.3%',
                        }}
                    >
                        <OddsButton
                            marketStatus={market.status}
                            outcomeStatus={outcome.status}
                            type={ODDS_BUTTON_TYPES.long}
                            changeType={outcome.changeType}
                            odd={outcome.odd}
                            isFrozen={isFrozen}
                            isClosed={isClosed}
                            selected={isSelected}
                            addToSlip={() => addToSlipHandler(market, outcome)}
                            removeFromSlip={() =>
                                onRemoveFromSlip({
                                    eventId: selectedEvent.id,
                                    marketId: market.id,
                                    outcomeId: outcome.outcomeRefId,
                                })
                            }
                        >
                            <div className={'flex justify-between'}>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '14px' }}>
                                            {formatSpecifierName({
                                                name: outcomeName,
                                                specifiers: market.specifiers,
                                                teams,
                                                tournamentName,
                                                playerNames,
                                            })}
                                        </span>
                                    }
                                >
                                    <span
                                        className={`${styles.outcomeName} ${
                                            isSelected ? styles.selected : ''
                                        }`}
                                    >
                                        {formatSpecifierName({
                                            name: outcomeName,
                                            specifiers: market.specifiers,
                                            teams,
                                            tournamentName,
                                            playerNames,
                                        })}
                                    </span>
                                </Tooltip>
                                <span>
                                    {renderOddContent({
                                        odd: outcome.odd,
                                        isClosed,
                                        isFrozen,
                                        marketStatus: market.status,
                                        outcomeStatus: outcome.status,
                                    })}
                                </span>
                            </div>
                        </OddsButton>
                    </div>
                ) : null;
            })}
        </div>
    );
};

export default Outcomes;
